<script>
    import { setMultiEdit } from '@/scripts/filesImages.js';

    export default {
        data() {
            return {
                selectAssetType: null,
            }
        },
        computed: {
            assetTypes() { return this.$store.getters.ASSET_TYPES },
            currentAssetType() { return this.$store.getters.MULTI_EDIT_ASSET_TYPE },
        },
        async mounted() {
            await this.baseMultiEdit();
        },
        methods: {
            async baseMultiEdit() {
                if (this.currentAssetType != null) {
                    this.selectAssetType = this.$store.getters.MULTI_EDIT_ASSET_TYPE;
                }
                else {
                    this.selectAssetType = this.$store.getters.ASSET_TYPE_IMAGES;
                    await this.$store.commit('MULTI_EDIT_ASSET_TYPE', this.selectAssetType);
                }
            },
            async startMultiEdit() {
                if (this.selectAssetType === await this.$store.getters.ASSET_TYPE_IMAGES) {
                    setMultiEdit(this.$store.getters.IMAGES)
                }
            },
            async clearData() {
                await this.$store.dispatch('MULTI_EDITE_CLEAR');
            },
            async closeMultiEdit() {
                await this.$store.commit('IS_SHOW_MULTI_EDIT', false);
            }
        }
    }
</script>


<template>
    <div>
        <button 
            class="button_blue_100 mr_10"
            @click="startMultiEdit"
        >Start Edit</button>
        <button 
            class="button_blue_100 mr_10"
            @click="clearData"
        >Clear</button>
        <select 
            v-model="selectAssetType"
            class="right_input"    
            style="padding: 3px;"
        > 
            <option
                v-for="(assetTypeValue, assetTypeIndex) in assetTypes" :key="assetTypeIndex"
                :value="assetTypeValue['id']"
            >
                {{ assetTypeValue['name'] }}
            </option>
        </select>
        <button
            class="close_button button_blue_100 mr_10"
            @click="closeMultiEdit"
        >Close</button>
    </div>
</template>